import React, { memo } from "react";

const RelatedImages = ({ relatedImages }) => <div>
  {(relatedImages && relatedImages.length > 0) ? relatedImages.map((item, idx) => (
    <a key={`${item.title}-${idx}`} className="relatedProduct" href={item.productUrl} target="_blank" rel="noreferrer" title={item.title}>
      <img
        src={item.imageUrl}
        alt={item.alt} />
      <div className="relatedProduct__name">{item.title}</div>
    </a>)) : null}
</div>

export default memo(RelatedImages);